import { createEnvironmentProjectAtoms } from "@amoreg/client-runtime/state/projects";
import { createProjectEnvironmentAtoms } from "@amoreg/client-runtime/state/projects";
import { createEnvironmentRpcQueryAtomFamily } from "@amoreg/client-runtime/state/runtime";
import { WS_METHODS } from "@amoreg/contracts";

import { environmentCatalog } from "../connection/catalog";
import { connectionAtomRuntime } from "../connection/runtime";
import { environmentSnapshotAtom } from "./shell";

export const projectEnvironment = createProjectEnvironmentAtoms(connectionAtomRuntime);
/**
 * Web-only: project content search backs the ⇧⌘F dialog, which has no mobile
 * surface, so the atom family lives here instead of the shared client-runtime
 * project atoms consumed by the mobile app.
 */
export const projectContentSearch = createEnvironmentRpcQueryAtomFamily(connectionAtomRuntime, {
  label: "environment-data:projects:search-contents",
  tag: WS_METHODS.projectsSearchContents,
  staleTimeMs: 5_000,
  idleTtlMs: 60_000,
});
/**
 * Web-only: the person's files across their other conversations, behind the
 * Files panel's "Other conversations" section. Keyed by organization and the
 * asking thread; the server applies the per-thread ownership rule.
 */
export const workspaceCatalog = createEnvironmentRpcQueryAtomFamily(connectionAtomRuntime, {
  label: "environment-data:workspace:list-across-threads",
  tag: WS_METHODS.workspaceListAcrossThreads,
  staleTimeMs: 30_000,
  idleTtlMs: 5 * 60_000,
});
export const environmentProjects = createEnvironmentProjectAtoms({
  catalogValueAtom: environmentCatalog.catalogValueAtom,
  snapshotAtom: environmentSnapshotAtom,
});
